function waitForCandidateChannel() {
  return new Promise(resolve => {
    const check = () => {
      if (window.candidateChannelConnected) {
        resolve();
      } else {
        setTimeout(check, 100);
      }
    };
    check();
  });
}

if ($('body').hasClass('page-compare')) {
  const companySlug = window.location.pathname.split('/')[2];

  waitForCandidateChannel().then(() => {
    const filters = $('.main-container').data('filters');
    const secureChannelName = $('.main-container').data('secure-channel-name');

    const data = {
      ...filters,
      secure_channel_name: secureChannelName,
    };

    $.ajax({
      type: 'GET',
      url: `/trabajar/${companySlug}/candidates/compare/new`,
      timeout: 30000,
      dataType: 'script',
      data,
      success() {},
      error() {},
    });
  });

  $('#compare-candidates-export-to-pdf').on('click', () => {
    window.print();
  });
}
